import affiliatesContent from "./content/affiliates.json";

export const affiliatesMock = {
  name: "affiliates",
  layoutType: 1,
  areasList: [
    {
      id: "affiliates-1",
      name: "affiliates-content",
      componentName: "Comp:AffiliatesPage",
      content: JSON.stringify(affiliatesContent),
    },
  ],
};
